"use client";

import { usePathname } from "next/navigation";
import { SupportNav } from "@/app/components/support/SupportNav";
import {
  TicketBackButton,
  isSupportNewPath,
  isSupportTicketDetailPath,
} from "@/app/components/support/supportTicketBack";
import { useSupportTicketBackHref } from "@/app/components/support/SupportTicketBackContext";

export function SupportMainToolbar() {
  const pathname = usePathname();
  const isTicketDetail = isSupportTicketDetailPath(pathname);
  const isNew = isSupportNewPath(pathname);
  const { backHref } = useSupportTicketBackHref();

  const showBackButton = isTicketDetail || isNew;

  return (
    <div className="flex items-center gap-1.5 md:gap-2 pb-5 mb-0">
      {showBackButton && (
        <TicketBackButton
          href={isNew ? "/support" : backHref}
          label={isNew ? "กลับไปบอร์ดซัพพอร์ต" : "กลับ"}
          mobileLabel={isNew ? "กลับบอร์ด" : "กลับ"}
          className="shrink-0"
        />
      )}
      {!showBackButton ? <SupportNav className="min-w-0 flex-1" /> : null}
    </div>
  );
}
